import { combineReducers } from 'redux';
import { Client } from 'store/Client/Client.types';
import {
  errorReducerCreator,
  itemsReducerCreator,
  loadingReducerCreator,
  pageReducerCreator,
  filterReducerCreator,
} from 'store/utils';
import {
  setFindClientName,
  asyncActions,
  findClientAsync,
  resetFind,
  clearFilters,
} from './AssignDevice.actions';

const items = itemsReducerCreator<Client.ExternalClient>({
  getterAsyncAction: findClientAsync,
  resetAction: resetFind,
  extended: [[[setFindClientName], () => []]],
});

const page = pageReducerCreator({
  listAsyncAction: findClientAsync,
  resetAction: resetFind,
});

const filter = filterReducerCreator<Partial<Client.FindFilters>>({
  setterAction: setFindClientName,
  resetAction: clearFilters,
  defaultState: { name: '' },
});
/**
 * Loading reducer ↓
 */
export const loading = loadingReducerCreator(asyncActions, {
  findClientAsync: { set: [setFindClientName] },
});

/**
 * Error reducer ↓
 */

export const error = errorReducerCreator(asyncActions);

export const assignDeviceReducer = combineReducers({
  items,
  page,
  filter,
  loading,
  error,
});
